export const getScheduleOrderState = ({ scheduleOrder }) => scheduleOrder

export const getRdvDispo = (state) => getScheduleOrderState(state).TabRdvDispo
export const getIsLoadingDisponibilite = (state) =>
  getScheduleOrderState(state).loading
